export default "__VITE_ASSET__BNSt1aAg__"